import React from 'react';
const Flexbox = ({
	left,
	right,
	extra=''
}) => {
	
	return(
		<h1 className={`section-heading ${extra}`}>
			<span>
				{left}
				<span className="line"></span>
			</span>
			<span>{right}</span>
		</h1>
	)
}
export default Flexbox;


// WEBPACK FOOTER //
// ./src/components/misc/Flexbox.js